import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'servicer',
    label: 'Servicer',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'transmitDate',
    label: 'Transmit Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicerLoanNumber',
    label: 'Servicer Loan Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'min',
    label: 'MIN / MERS Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicingOwnershipType',
    label: 'Servicing Ownership Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicingStatus',
    label: 'Servicing Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicingStartDate',
    label: 'Servicing Start Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicingEndDate',
    label: 'Servicing End Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'poolNumber',
    label: 'Pool Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorType',
    label: 'Investor Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const serviceInformationForm = {
  name: FormNames.POST_CLOSING,
  label: 'Servicer Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
